<template>
  <div v-if="isVisible && !hasChildModalOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-container" @click.stop>
      <div class="modal-scroll-wrapper">
      <div class="modal-header">
        <button @click="closeModal" class="back-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.97461 4.81836C8.01029 4.81846 8.04105 4.83207 8.0625 4.85352C8.08387 4.87503 8.09668 4.9057 8.09668 4.94141C8.09665 4.97713 8.08392 5.0078 8.0625 5.0293L3.0918 10L3.44531 10.3535L8.0625 14.9697C8.08394 14.9912 8.0966 15.0219 8.09668 15.0576C8.09668 15.0935 8.08403 15.125 8.0625 15.1465L8.05078 15.1582C8.04751 15.1617 8.04021 15.1683 8.02637 15.1738C8.01186 15.1796 7.99339 15.1826 7.97461 15.1826C7.95701 15.1826 7.94101 15.1801 7.92773 15.1748C7.91489 15.1696 7.90041 15.1611 7.88574 15.1465L2.82812 10.0879C2.80668 10.0664 2.79306 10.0357 2.79297 10C2.79297 9.96415 2.8066 9.93266 2.82812 9.91113L7.88574 4.85352C7.90727 4.83199 7.93876 4.81836 7.97461 4.81836Z" fill="#282A36" stroke="#282A36"/>
            <path d="M3.05859 9.875H17.084C17.114 9.87511 17.1454 9.88755 17.1709 9.91309C17.1964 9.93869 17.209 9.96993 17.209 10C17.209 10.0301 17.1964 10.0613 17.1709 10.0869C17.1454 10.1124 17.114 10.1249 17.084 10.125H3.05859C3.02845 10.125 2.99732 10.1126 2.97168 10.0869C2.94604 10.0613 2.93359 10.0301 2.93359 10C2.93359 9.96985 2.94604 9.93873 2.97168 9.91309C2.99732 9.88744 3.02845 9.875 3.05859 9.875Z" fill="#282A36" stroke="#282A36"/>
          </svg>
        </button>
      </div>

      <div class="modal-content">
        <div class="left-section">
          <div class="payment-section">
            <div class="payment-method-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M29.3346 12V21.9467C29.3346 25 26.8546 27.4667 23.8013 27.4667H8.2013C5.14797 27.4667 2.66797 25 2.66797 21.9467V12H29.3346Z" fill="#4A68F8"/>
                <path d="M29.3346 10.0532V11.9999H2.66797V10.0532C2.66797 6.99987 5.14797 4.5332 8.2013 4.5332H23.8013C26.8546 4.5332 29.3346 6.99987 29.3346 10.0532Z" fill="#4A68F8"/>
                <path d="M10.6667 23H8C7.45333 23 7 22.5467 7 22C7 21.4533 7.45333 21 8 21H10.6667C11.2133 21 11.6667 21.4533 11.6667 22C11.6667 22.5467 11.2133 23 10.6667 23Z" fill="#4A68F8"/>
                <path d="M19.3333 23H14C13.4533 23 13 22.5467 13 22C13 21.4533 13.4533 21 14 21H19.3333C19.88 21 20.3333 21.4533 20.3333 22C20.3333 22.5467 19.88 23 19.3333 23Z" fill="#4A68F8"/>
              </svg>
              <span class="section-title">{{$t('payment_information')}}</span>
            </div>

            <div class="dot"></div>

            <div class="billing-info">
              <h3 class="subsection-title">
                {{$t('billing_information')}}
                <button @click="openPricingInformation" class="edit-button">{{$t('edit')}}</button>
              </h3>
              <div class="billing-details">
                <div v-if="!billingInfo" class="no-data">
                  <p class="name">{{$t('billing_not_found')}}</p>
                  <p class="address">{{$t('please_add_billing')}}</p>
                  <p class="phone">-</p>
                </div>

                <div v-else>
                  <p v-if="billingInfo.billingType === 'individual'" class="name">
                    {{ billingInfo.name || 'Ad soyad girilmemiş' }}
                  </p>

                  <p v-if="billingInfo.billingType === 'corporate'" class="name">
                    {{ billingInfo.companyName || 'Şirket adı girilmemiş' }}
                  </p>

                  <p class="address">{{ billingInfo.address || 'Adres girilmemiş' }}</p>
                  <p class="phone">{{ billingInfo.phone || 'Telefon girilmemiş' }}</p>
                </div>
              </div>
            </div>

            <div class="dot"></div>

            <div class="payment-method">
              <div class="payment-header">
                <div class="card-select-wrapper" v-click-outside="closeCardDropdown">
                  <div v-if="paymentMethods.length > 0" class="card-select-trigger" @click="cardDropdownOpen = !cardDropdownOpen">
                    <div class="card-select-display">
                      <img v-if="selectedCard" :src="'/card/'+selectedCard.cardBrand+'.svg'" alt="" class="card-select-icon" />
                      <span v-if="selectedCard" class="card-select-text">
                        {{ getCardBrandName(selectedCard.cardBrand) }} {{ selectedCard.maskedCardNumber }}
                        <span class="card-select-expiry">{{ String(selectedCard.expiryMonth).padStart(2, '0') }}/{{ selectedCard.expiryYear }}</span>
                      </span>
                      <span v-else class="card-select-placeholder">{{ $t('select_card') }}</span>
                    </div>
                    <img src="@/assets/images/arrowdown.svg" class="card-select-arrow" :class="{ 'rotated': cardDropdownOpen }" />
                  </div>

                  <div v-else class="no-card-info">
                    <span>{{$t('no_card_added')}}</span>
                  </div>

                  <div v-if="cardDropdownOpen" class="card-select-dropdown">
                    <div
                        v-for="card in paymentMethods"
                        :key="card.cardId"
                        class="card-select-option"
                        :class="{ 'selected': selectedCardId === card.cardId }"
                        @click="selectCard(card.cardId)"
                    >
                      <img :src="'/card/'+card.cardBrand+'.svg'" alt="" class="card-select-icon" />
                      <div class="card-option-details">
                        <span class="card-option-brand">{{ getCardBrandName(card.cardBrand) }}</span>
                        <span class="card-option-number">{{ card.maskedCardNumber }}</span>
                      </div>
                      <span class="card-option-expiry">{{ String(card.expiryMonth).padStart(2, '0') }}/{{ card.expiryYear }}</span>
                    </div>
                  </div>
                </div>

                <button class="new-card-button" @click="openAddCardModal">{{$t('add_new_card')}}</button>
              </div>
            </div>

            <div class="dot"></div>

            <button class="complete-payment-btn" :disabled="paymentLoading || !billingInfo?.billingId || !(selectedCardId || primaryCard?.cardId)" @click="completePayment">
              <span v-if="paymentLoading" class="spinner-border spinner-border-sm me-1"></span>
              {{ paymentLoading ? $t('processing') : $t('complete_payment') }}
            </button>

            <!-- Buton neden disabled: kullaniciya gorsel hint -->
            <p v-if="!paymentLoading && !billingInfo?.billingId" class="payment-disabled-hint">
              {{ $t('billing_required_before_payment') || 'Odeme yapabilmek icin once fatura adresi ekleyin.' }}
            </p>
            <p v-else-if="!paymentLoading && !(selectedCardId || primaryCard?.cardId)" class="payment-disabled-hint">
              {{ $t('card_required_before_payment') || 'Odeme yapabilmek icin once kart ekleyin.' }}
            </p>

           <!-- <div class="payment-notice">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 13.25C10.4518 13.25 13.25 10.4518 13.25 7C13.25 3.54822 10.4518 0.75 7 0.75C3.54822 0.75 0.75 3.54822 0.75 7C0.75 10.4518 3.54822 13.25 7 13.25ZM8.11584 10.2086L8.21565 9.8006C8.16399 9.82486 8.0807 9.85258 7.96649 9.88414C7.85197 9.9157 7.7489 9.93177 7.65831 9.93177C7.46536 9.93177 7.32952 9.90014 7.25065 9.83657C7.17236 9.773 7.13331 9.65342 7.13331 9.47827C7.13331 9.40887 7.14509 9.30542 7.16973 9.17003C7.19361 9.03373 7.22108 8.91261 7.25161 8.80666L7.62419 7.48759C7.66068 7.36653 7.68571 7.23344 7.69916 7.08818C7.71292 6.94325 7.71932 6.84185 7.71932 6.78429C7.71932 6.50614 7.62182 6.28041 7.42676 6.10629C7.2317 5.93229 6.95393 5.84529 6.59396 5.84529C6.39365 5.84529 6.18188 5.88088 5.95776 5.95201C5.73363 6.02294 5.49933 6.1084 5.25421 6.2082L5.15415 6.6165C5.22719 6.58949 5.31419 6.56043 5.41598 6.53034C5.51732 6.50038 5.61674 6.48489 5.71347 6.48489C5.91096 6.48489 6.04399 6.51856 6.1137 6.58488C6.18342 6.65139 6.21844 6.7697 6.21844 6.93883C6.21844 7.03236 6.20736 7.13626 6.18438 7.24919C6.16172 7.36282 6.13342 7.48298 6.10013 7.6098L5.72595 8.93419C5.69266 9.07336 5.66834 9.19787 5.65304 9.30843C5.63786 9.41886 5.63057 9.52724 5.63057 9.63262C5.63057 9.90482 5.73114 10.1292 5.93222 10.3063C6.13329 10.4826 6.41523 10.5714 6.77769 10.5714C7.01372 10.5714 7.22088 10.5406 7.39917 10.4785C7.57727 10.4167 7.81644 10.3268 8.11584 10.2086ZM8.04946 4.8502C8.22352 4.68882 8.31014 4.49254 8.31014 4.26272C8.31014 4.03341 8.22365 3.83675 8.04946 3.67331C7.87584 3.51032 7.66657 3.42857 7.4219 3.42857C7.17646 3.42857 6.96635 3.51013 6.79107 3.67331C6.61579 3.83675 6.52796 4.03334 6.52796 4.26272C6.52796 4.49254 6.61579 4.68875 6.79107 4.8502C6.96667 5.01217 7.17639 5.09321 7.4219 5.09321C7.66664 5.09321 7.87584 5.01217 8.04946 4.8502Z" fill="#D0D5DD"/>
              </svg>
              <p>{{$t('pricing_information_description')}}.</p>
            </div>-->
          </div>
        </div>

        <div class="right-section">
          <div class="plan-header">
            <div class="plan-icon">
              <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M44.3281 17.002C44.3281 24.182 38.5081 30.002 31.3281 30.002C30.9881 30.002 30.6281 29.9819 30.2881 29.9619C29.7881 23.6219 24.7081 18.542 18.3681 18.042C18.3481 17.702 18.3281 17.342 18.3281 17.002C18.3281 9.82195 24.1481 4.00195 31.3281 4.00195C38.5081 4.00195 44.3281 9.82195 44.3281 17.002Z" fill="#3DA33E"/>
                <path opacity="0.4" d="M30.3301 31C30.3301 38.18 24.5101 44 17.3301 44C10.1501 44 4.33008 38.18 4.33008 31C4.33008 23.82 10.1501 18 17.3301 18C17.6701 18 18.0301 18.02 18.3701 18.04C24.7101 18.54 29.7901 23.62 30.2901 29.96C30.3101 30.3 30.3301 30.66 30.3301 31Z" fill="#3DA33E"/>
                <path d="M15.5681 29.238L17.3281 25.998L19.0881 29.238L22.3281 30.998L19.0881 32.7581L17.3281 35.998L15.5681 32.7581L12.3281 30.998L15.5681 29.238Z" fill="#3DA33E"/>
              </svg>
            </div>
            <div class="plan-info">
              <h3 class="plan-name">{{ planTitle || 'Plan yükleniyor...' }}</h3>
              <p class="plan-description">{{ planDescription || 'Plan açıklaması yükleniyor...' }}</p>
            </div>
          </div>

          <div class="dot"></div>

          <div class="plan-features">
            <span class="features-title">{{$t('included_in_your_package')}}:</span>

            <div v-if="!currentPlanData && !selectedPackage" class="loading-text pb-4" style="font-size: 12px; color: #6b7380;">
              {{$t('feature_load')}}
            </div>

            <ul v-else-if="planFeatures.length > 0" class="features-list">
              <li v-for="feature in planFeatures" :key="feature">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.49956 12.8772L15.3936 5.98242L16.4548 7.04292L8.49956 14.9982L3.72656 10.2252L4.78706 9.16467L8.49956 12.8772Z" fill="#101828"/>
                </svg>
                {{ feature }}
              </li>
            </ul>

            <div v-else class="no-features">
              {{$t('plan_features_not_found')}}
            </div>
          </div>

          <div class="dot"></div>

          <div class="pricing-summary">
            <h4 class="summary-title">{{$t('transaction_summary')}}</h4>

            <div v-if="!currentPlanData && !selectedPackage" class="loading-text" style="font-size: 12px; color: #6b7380;">
              {{$t('loading_price_information')}}
            </div>

            <div v-else>
              <div class="pricing-row">
                <span class="pricing-label">${{ monthlyPrice || 0 }} x {{ billingPeriod || '-' }}</span>
                <span class="pricing-value">${{ totalPrice || 0 }}</span>
              </div>

              <div class="pricing-row discount" v-if="discount > 0">
                <span class="pricing-label">{{ selectedPackage?.upgradeInfo ? $t('prorated_credit') : $t('annual_package_discount') }}</span>
                <span class="pricing-value discount-value">-${{ discount }}</span>
              </div>

              <div class="pricing-row">
                <span class="pricing-label">{{$t('taxes')}}</span>
                <span class="pricing-value">${{ taxes || 0 }}</span>
              </div>

              <div class="pricing-row">
                <span class="pricing-label">{{$t('payable_today')}}</span>
                <span class="pricing-value">${{ todayPayment || 0 }}</span>
              </div>
            </div>
          </div>

          <div class="payment-schedule">
            <div class="schedule-header">
              <div class="schedule-left">
                <span class="monthly-amount">{{ isAnnual ? $t('yearly_total') : $t('monthly_total') }}</span>
                <span class="monthly-price">${{ todayPayment || 0 }}</span>
              </div>
              <div class="schedule-right">
                <div class="date-range">
                  <div class="date-item">
                    <span class="date-label">{{$t('start_date')}}</span>
                    <span class="date-value">{{ startDate || '--' }}</span>
                  </div>

                  <div class="date-item">
                    <span class="date-label">{{$t('finish_date')}}</span>
                    <span class="date-value">{{ nextPaymentDate || '--' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="dot"></div>

          <div class="billing-notice">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 13.25C10.4518 13.25 13.25 10.4518 13.25 7C13.25 3.54822 10.4518 0.75 7 0.75C3.54822 0.75 0.75 3.54822 0.75 7C0.75 10.4518 3.54822 13.25 7 13.25ZM8.11584 10.2086L8.21565 9.8006C8.16399 9.82486 8.0807 9.85258 7.96649 9.88414C7.85197 9.9157 7.7489 9.93177 7.65831 9.93177C7.46536 9.93177 7.32952 9.90014 7.25065 9.83657C7.17236 9.773 7.13331 9.65342 7.13331 9.47827C7.13331 9.40887 7.14509 9.30542 7.16973 9.17003C7.19361 9.03373 7.22108 8.91261 7.25161 8.80666L7.62419 7.48759C7.66068 7.36653 7.68571 7.23344 7.69916 7.08818C7.71292 6.94325 7.71932 6.84185 7.71932 6.78429C7.71932 6.50614 7.62182 6.28041 7.42676 6.10629C7.2317 5.93229 6.95393 5.84529 6.59396 5.84529C6.39365 5.84529 6.18188 5.88088 5.95776 5.95201C5.73363 6.02294 5.49933 6.1084 5.25421 6.2082L5.15415 6.6165C5.22719 6.58949 5.31419 6.56043 5.41598 6.53034C5.51732 6.50038 5.61674 6.48489 5.71347 6.48489C5.91096 6.48489 6.04399 6.51856 6.1137 6.58488C6.18342 6.65139 6.21844 6.7697 6.21844 6.93883C6.21844 7.03236 6.20736 7.13626 6.18438 7.24919C6.16172 7.36282 6.13342 7.48298 6.10013 7.6098L5.72595 8.93419C5.69266 9.07336 5.66834 9.19787 5.65304 9.30843C5.63786 9.41886 5.63057 9.52724 5.63057 9.63262C5.63057 9.90482 5.73114 10.1292 5.93222 10.3063C6.13329 10.4826 6.41523 10.5714 6.77769 10.5714C7.01372 10.5714 7.22088 10.5406 7.39917 10.4785C7.57727 10.4167 7.81644 10.3268 8.11584 10.2086ZM8.04946 4.8502C8.22352 4.68882 8.31014 4.49254 8.31014 4.26272C8.31014 4.03341 8.22365 3.83675 8.04946 3.67331C7.87584 3.51032 7.66657 3.42857 7.4219 3.42857C7.17646 3.42857 6.96635 3.51013 6.79107 3.67331C6.61579 3.83675 6.52796 4.03334 6.52796 4.26272C6.52796 4.49254 6.61579 4.68875 6.79107 4.8502C6.96667 5.01217 7.17639 5.09321 7.4219 5.09321C7.66664 5.09321 7.87584 5.01217 8.04946 4.8502Z" fill="#D0D5DD"/>
            </svg>
            <p>{{ currentPlanInfo?.firstPaymentMessage || 'Ödeme bilgisi yükleniyor...' }}</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <PricingSuccessModal
      v-if="showSuccessModal && !hasChildModalOpen"
      :isVisible="showSuccessModal"
      :planName="planTitle"
      :amount="todayPayment"
      :billingPeriod="billingPeriod"
      @close="closeSuccessModal"
  />

  <PricingInformation
      v-if="showPricingInformation"
      :isVisible="showPricingInformation"
      :billingInfo="{
      billingId: billingInfo?.billingId,
      billingType: billingInfo?.billingType || 'individual',
      firstName: billingInfo?.firstName,
      lastName: billingInfo?.lastName,
      companyName: billingInfo?.companyName,
      taxNumber: billingInfo?.taxNumber,
      taxOffice: billingInfo?.taxOffice,
      country: billingInfo?.country,
      city: billingInfo?.city,
      cityName: billingInfo?.cityName,
      addressLine: billingInfo?.addressLine,
      postalCode: billingInfo?.postalCode,
      phone: billingInfo?.phone,
      email: billingInfo?.email,
      isDefault: billingInfo?.isDefault,
      isActive: billingInfo?.isActive
    }"
      :mode="'update'"
      @close="closePricingInformation"
      @save="onBillingInfoSaved"
  />

  <PricingAddNewCardModal
      v-if="isAddCardModalOpen"
      :isVisible="isAddCardModalOpen"
      @close="closeAddCardModal"
      @save="onCardSave"
  />
</template>

<script>
import PricingSuccessModal from './PricingSuccessModal.vue'
import pricingService from '@/service/pricingService'
import PricingInformation from "@/components/modals/PricingInformation.vue"
import PricingAddNewCardModal from '@/components/modals/PricingAddNewCardModal.vue'
export default {
  name: 'PaymentCard',
  components: {
    PricingSuccessModal,
    PricingInformation,
    PricingAddNewCardModal
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    selectedPackage: {
      type: Object,
      default: null
    },
    selectedPlan: {
      type: String,
      default: 'starter'
    },
    isAnnual: {
      type: Boolean,
      default: true
    },
    paymentMethodsProp: {
      type: [Array, Object],
      default: null
    },
    billingHistoryProp: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      currentPlanInfo: null,
      currentPlanData: null,
      showSuccessModal: false,
      showPricingInformation: false,
      isAddCardModalOpen: false,
      paymentMethods: [],
      selectedCardId: null,
      cardDropdownOpen: false,
      loading: false,
      billingLoading: false,
      billingInfo: null,
      paymentLoading: false
    }
  },

  computed: {
    hasChildModalOpen() {
      return this.showPricingInformation || this.isAddCardModalOpen;
    },

    primaryCard() {
      const primary = this.paymentMethods?.find(card => card.isPrimary);
      return primary;
    },

    selectedCard() {
      if (!this.selectedCardId || !this.paymentMethods?.length) return null;
      return this.paymentMethods.find(card => card.cardId === this.selectedCardId);
    },

    planTitle() {
      if (this.selectedPackage?.name) {
        return `${this.selectedPackage.name} Paket`;
      }

      return this.currentPlanData?.package?.name
          ? `${this.currentPlanData.package.name} Paket`
          : this.planConfig.title;
    },

    planDescription() {
      if (this.selectedPackage?.shortDescription) {
        return this.selectedPackage.shortDescription;
      }

      return this.currentPlanData?.package?.shortDescription || this.planConfig.description;
    },

    planFeatures() {
      if (this.selectedPackage?.description) {
        const description = this.selectedPackage.description;
        const cleanText = description.replace(/<[^>]*>/g, '\n');
        const lines = cleanText.split('\n')
            .map(line => line.trim())
            .filter(line => line && line.length > 5);

        const uniqueFeatures = [...new Set(lines)];
        return uniqueFeatures.slice(0, 6);
      }

      if (this.currentPlanData?.package?.description) {
        const description = this.currentPlanData.package.description;
        const cleanText = description.replace(/<[^>]*>/g, '\n');
        const lines = cleanText.split('\n')
            .map(line => line.trim())
            .filter(line => line && line.length > 5);

        const uniqueFeatures = [...new Set(lines)];
        return uniqueFeatures.slice(0, 6);
      }

      return this.planConfig.features;
    },

    basePrice() {
      if (this.selectedPackage) {
        const price = this.isAnnual
            ? parseFloat(this.selectedPackage.yearlyPrice || 0)
            : parseFloat(this.selectedPackage.monthlyPrice || 0);
        return price.toFixed(2);
      }

      const price = parseFloat(this.currentPlanData?.packageInfo?.basePrice || 0);
      return price.toFixed(2);
    },

    billingPeriod() {
      if (this.selectedPackage) {
        return this.isAnnual ? '12 Ay' : '1 Ay';
      }

      const period = this.currentPlanData?.packageInfo?.billingPeriod;
      if (period === 'yearly') return '12 Ay';
      if (period === 'monthly') return '1 Ay';
      return this.isAnnual ? '12 Ay' : '1 Ay';
    },

    totalPrice() {
      const price = parseFloat(this.basePrice);
      return price.toFixed(2);
    },

    taxes() {
      if (this.selectedPackage?.upgradeInfo) {
        const amountDue = this.isAnnual
            ? parseFloat(this.selectedPackage.upgradeInfo.yearlyAmountDue || 0)
            : parseFloat(this.selectedPackage.upgradeInfo.monthlyAmountDue || 0);
        return (amountDue * 0.20).toFixed(2);
      }

      const total = parseFloat(this.totalPrice);
      const discountAmount = parseFloat(this.discount);
      return ((total - discountAmount) * 0.20).toFixed(2);
    },

    discount() {
      if (this.selectedPackage?.upgradeInfo) {
        const credit = parseFloat(this.selectedPackage.upgradeInfo.proratedCredit || 0);
        if (credit > 0) return credit.toFixed(2);

        const fullPrice = parseFloat(this.basePrice);
        const amountDue = this.isAnnual
            ? parseFloat(this.selectedPackage.upgradeInfo.yearlyAmountDue || 0)
            : parseFloat(this.selectedPackage.upgradeInfo.monthlyAmountDue || 0);
        const diff = fullPrice - amountDue;
        if (diff > 0) return diff.toFixed(2);
      }
      return '0.00';
    },

    todayPayment() {
      if (this.selectedPackage?.upgradeInfo) {
        const amountDue = this.isAnnual
            ? parseFloat(this.selectedPackage.upgradeInfo.yearlyAmountDue || 0)
            : parseFloat(this.selectedPackage.upgradeInfo.monthlyAmountDue || 0);
        const tax = amountDue * 0.20;
        return (amountDue + tax).toFixed(2);
      }

      const total = parseFloat(this.totalPrice);
      const tax = parseFloat(this.taxes);
      const discount = parseFloat(this.discount);

      return (total + tax - discount).toFixed(2);
    },

    monthlyTotal() {
      const basePrice = parseFloat(this.basePrice);

      if (this.isAnnual) {
        return (basePrice / 12).toFixed(2);
      }

      return basePrice.toFixed(2);
    },

    nextPaymentDate() {
      const packageStatus = this.currentPlanData?.packageStatus;
      const isDemo = packageStatus?.type === 'demo';

      if (!isDemo) {
        const today = new Date();
        const endDateCalc = new Date(today);
        if (this.isAnnual) {
          endDateCalc.setFullYear(endDateCalc.getFullYear() + 1);
        } else {
          endDateCalc.setMonth(endDateCalc.getMonth() + 1);
        }
        return this.formatDateByLocale(endDateCalc.toISOString());
      }

      const endDate = this.currentPlanData?.packageInfo?.endDate;
      if (endDate) {
        return this.formatDateByLocale(endDate);
      }

      const start = new Date();
      if (this.isAnnual) {
        start.setFullYear(start.getFullYear() + 1);
      } else {
        start.setMonth(start.getMonth() + 1);
      }
      return this.formatDateByLocale(start.toISOString());
    },

    startDate() {
      const packageStatus = this.currentPlanData?.packageStatus;
      const isDemo = packageStatus?.type === 'demo';

      if (!isDemo) {
        return this.formatDateByLocale(new Date().toISOString());
      }

      const startDateStr = this.currentPlanData?.packageInfo?.startDate;
      if (startDateStr) {
        return this.formatDateByLocale(startDateStr);
      }

      return this.formatDateByLocale(new Date().toISOString());
    },

    currentPlanInfo() {
      if (this.selectedPackage) {
        const periodText = this.isAnnual ? 'yıllık' : 'aylık';
        return {
          firstPaymentMessage: `İlk ödemeniz bugün alınacak ve ${periodText} olarak faturalandırılacaktır.`
        };
      }
      return {
        firstPaymentMessage: this.currentPlanData?.packageInfo?.messages?.first_payment
            || this.currentPlanData?.packageInfo?.messages?.package_expiry
            || 'Ödeme bilgisi yükleniyor...'
      };
    },

    planConfig() {
      const configs = {
        starter: {
          title: 'Başlangıç Paketi',
          description: 'Denemek ve keşfetmek isteyen başlangıç kullanıcıları için',
          features: [
            '0-1000 bağlantı anonim program paylaşımı',
            'Standart program oluşturma',
            'Dokuman dönüştürücü',
            'Web bağlantısı ile program paylaşma'
          ],
          basePrice: this.isAnnual ? 89 : 109,
          monthlyRate: this.isAnnual ? 7.42 : 109
        },
        advanced: {
          title: 'Gelişmiş Paket',
          description: 'Anında program hazırlanıp paylaşmak isteyen ekipler için',
          features: [
            '0-1000 bağlantı anonim program paylaşımı',
            'Standart program oluşturma',
            'Dokuman dönüştürücü',
            'Web bağlantısı ile program paylaşma',
            'Mobil uygulama desteği'
          ],
          basePrice: this.isAnnual ? 399 : 499,
          monthlyRate: this.isAnnual ? 33.25 : 499
        },
        enterprise: {
          title: 'Kurumsal Paket',
          description: 'Büyük şirketler ve kurumsal kullanıcılar için',
          features: [
            '250+ Mobil App kullanıcısı',
            'Özelleştirilebilir marka',
            'Özel entegrasyonlar',
            'Özel raporlama',
            'Web bağlantısı ile program paylaşma'
          ],
          basePrice: 999,
          monthlyRate: 83.25
        }
      };

      return configs[this.selectedPlan] || configs.starter;
    },

    monthlyPrice() {
      if (this.selectedPackage) {
        if (this.isAnnual) {
          const yearlyPrice = parseFloat(this.selectedPackage.yearlyPrice || 0);
          return (yearlyPrice / 12).toFixed(2);
        }

        return parseFloat(this.selectedPackage.monthlyPrice || 0).toFixed(2);
      }

      const basePrice = parseFloat(this.currentPlanData?.packageInfo?.basePrice || 0);
      const billingPeriod = this.currentPlanData?.packageInfo?.billingPeriod;

      if (billingPeriod === 'yearly') {
        return (basePrice / 12).toFixed(2);
      }

      return basePrice.toFixed(2);
    },

  },

  watch: {
    isVisible: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          await this.loadData();
        }
      }
    }
  },

  async created() {
    if (this.isVisible) {
      await this.loadData();
    }
  },

  methods: {
    async loadData() {
      try {
        const tasks = [];

        if (this.paymentMethodsProp?.data?.length) {
          this.paymentMethods = this.paymentMethodsProp.data;
        } else {
          tasks.push(this.loadPaymentMethods());
        }

        if (this.billingHistoryProp?.data?.length) {
          this.setBillingInfoFromProp(this.billingHistoryProp.data);
        } else {
          tasks.push(this.loadBillingInfo());
        }

        if (tasks.length) {
          await Promise.allSettled(tasks);
        }
      } catch (error) {
      }
    },

    setBillingInfoFromProp(billingData) {
      if (billingData.length > 0) {
        const defaultBilling = billingData.find(item => item.isActive && item.isDefault) || billingData[0];
        this.billingInfo = {
          billingId: defaultBilling.billingId,
          name: `${defaultBilling.firstName || ''} ${defaultBilling.lastName || ''}`.trim(),
          email: defaultBilling.email || null,
          phone: defaultBilling.phone || null,
          location: this.formatLocation(defaultBilling.countryName, defaultBilling.cityName),
          postalCode: defaultBilling.postalCode || null,
          address: defaultBilling.addressLine || null,
          companyName: defaultBilling.companyName || '',
          billingType: defaultBilling.billingType || 'individual',
          firstName: defaultBilling.firstName || '',
          lastName: defaultBilling.lastName || '',
          country: defaultBilling.country || '',
          city: defaultBilling.city || '',
          countryName: defaultBilling.countryName || '',
          cityName: defaultBilling.cityName || '',
          addressLine: defaultBilling.addressLine || '',
          taxNumber: defaultBilling.taxNumber || '',
          taxOffice: defaultBilling.taxOffice || '',
          district: defaultBilling.district || '',
          isDefault: defaultBilling.isDefault || true,
          isActive: defaultBilling.isActive || true
        };
      } else {
        this.billingInfo = null;
      }
    },

    async loadBillingInfo() {
      try {
        this.billingLoading = true;

        const response = await pricingService.getBillingInfo();

        if (response?.data?.responseType === 'success') {
          const billingData = response.data?.data?.data || [];

          if (billingData.length > 0) {
            const defaultBilling = billingData.find(item => item.isActive && item.isDefault) || billingData[0];

            this.billingInfo = {
              billingId: defaultBilling.billingId,
              name: `${defaultBilling.firstName || ''} ${defaultBilling.lastName || ''}`.trim(),
              email: defaultBilling.email || null,
              phone: defaultBilling.phone || null,
              location: this.formatLocation(defaultBilling.countryName, defaultBilling.cityName),
              postalCode: defaultBilling.postalCode || null,
              address: defaultBilling.addressLine || null,
              companyName: defaultBilling.companyName || '',
              billingType: defaultBilling.billingType || 'individual',
              firstName: defaultBilling.firstName || '',
              lastName: defaultBilling.lastName || '',
              country: defaultBilling.country || '',
              city: defaultBilling.city || '',
              countryName: defaultBilling.countryName || '',
              cityName: defaultBilling.cityName || '',
              addressLine: defaultBilling.addressLine || '',
              taxNumber: defaultBilling.taxNumber || '',
              taxOffice: defaultBilling.taxOffice || '',
              district: defaultBilling.district || '',
              isDefault: defaultBilling.isDefault || true,
              isActive: defaultBilling.isActive || true
            };

          } else {
            this.billingInfo = null;
          }
        } else {
          throw new Error('API response başarısız');
        }
      } catch (error) {
        this.billingInfo = null;
      } finally {
        this.billingLoading = false;
      }
    },

    async loadPaymentMethods() {
      try {
        this.loading = true;

        const response = await pricingService.getPaymentMethods();

        if (response?.data?.responseType === 'success') {
          this.paymentMethods = response.data?.data?.data || [];
        } else {
          this.paymentMethods = [];
        }

        if (this.paymentMethods.length > 0) {
          const primary = this.paymentMethods.find(card => card.isPrimary);
          this.selectedCardId = primary ? primary.cardId : this.paymentMethods[0].cardId;
        }
      } catch (error) {
        this.paymentMethods = [];
      } finally {
        this.loading = false;
      }
    },

    async loadCurrentPlan() {
      try {
        const response = await pricingService.getCurrentPlan();

        if (response?.data?.responseType === 'success') {
          this.currentPlanData = response.data?.data;
        }
      } catch (error) {
        this.currentPlanData = null;
      }
    },

    formatLocation(country, city) {
      if (!country && !city) return null;
      if (!country) return city;
      if (!city) return country;
      return `${country}, ${city}`;
    },

    formatDateByLocale(dateString) {
      if (!dateString) return this.$t('date_unknown') || 'Tarih belirsiz';

      const date = new Date(dateString);
      const locale = this.$i18n?.locale || 'tr';

      return date.toLocaleDateString(locale === 'tr' ? 'tr-TR' : 'en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    },

    getCardBrandName(brandCode) {
      const brandNames = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'amex': 'American Express',
        'jcb': 'JCB',
        'discover': 'Discover',
        'diners': 'Diners Club',
        'unionpay': 'Union Pay',
        'maestro': 'Maestro',
        'mir': 'Mir',
        'troy': 'Troy',
        'elo': 'Elo',
        'hipercard': 'Hipercard'
      }

      return brandNames[brandCode?.toLowerCase()] || brandCode || 'Credit Card'
    },

    closeModal() {
      this.$emit('close');
    },

    selectCard(cardId) {
      this.selectedCardId = cardId;
      this.cardDropdownOpen = false;
    },

    closeCardDropdown() {
      this.cardDropdownOpen = false;
    },

    openAddCardModal() {
      this.isAddCardModalOpen = true;
    },

    openPricingInformation() {
      this.showPricingInformation = true;
    },

    closePricingInformation() {
      this.showPricingInformation = false;
    },

    async onBillingInfoSaved(updatedBillingInfo) {
      this.showPricingInformation = false;
      await this.loadBillingInfo();
    },

    async onCardSave(cardData) {
      this.isAddCardModalOpen = false;
      await this.loadPaymentMethods();
    },

    async completePayment() {
      if (this.paymentLoading) return;

      if (!this.billingInfo?.billingId) {
        this.$snackbar?.add({
          text: this.$t('please_add_billing'),
          type: 'error'
        });
        this.openPricingInformation();
        return;
      }

      if (!this.selectedCardId && !this.primaryCard?.cardId) {
        this.$snackbar?.add({
          text: this.$t('please_select_card'),
          type: 'error'
        });
        return;
      }

      this.paymentLoading = true;
      try {
        const payableAmount = this.selectedPackage?.upgradeInfo
          ? (this.isAnnual
              ? parseFloat(this.selectedPackage.upgradeInfo.yearlyAmountDue || 0)
              : parseFloat(this.selectedPackage.upgradeInfo.monthlyAmountDue || 0)).toFixed(2)
          : this.basePrice;

        const paymentData = {
          planId: this.selectedPackage?.packageId || this.currentPlanData?.id,
          billingPeriod: this.isAnnual ? 'yearly' : 'monthly',
          billingId: this.billingInfo?.billingId,
          cardId: this.selectedCardId || this.primaryCard?.cardId,
          amount: payableAmount,
          installment: 0
        };

        const response = await pricingService.processPayment(paymentData);

        if (response?.data?.responseType === 'success') {
          this.showSuccessModal = true;

          this.$emit('complete-payment', {
            planName: this.planTitle,
            amount: payableAmount,
            billingPeriod: this.billingPeriod
          });
        } else {
          const errorMessage = response?.data?.message || this.$t('payment_failed');
          this.$snackbar?.add({
            text: errorMessage,
            type: 'error'
          });
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message || this.$t('payment_failed');
        this.$snackbar?.add({
          text: errorMessage,
          type: 'error'
        });
      } finally {
        this.paymentLoading = false;
      }
    },

    closeAddCardModal() {
      this.isAddCardModalOpen = false;
    },

    closeSuccessModal() {
      this.showSuccessModal = false;
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-container {
  background: #ffffff;
  border-radius: 24px;
  width: 1150px;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
}

.modal-scroll-wrapper {
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 0;
}

.back-button {
  background: #f8f9fa;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.back-button:hover {
  background-color: #e5e7eb;
  color: #374151;
}

.modal-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px;
}

.left-section {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 12px;
  align-self: start;
}

.payment-method-icon {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.payment-method-icon span {
  font-size: 20px;
  font-family: 'euclid_semi_bold', sans-serif;
}

.section-title {
  font-size: 24px;
  color: #111827;
  margin: 0 0 32px 0;
}

.subsection-title {
  font-size: 16px;
  color: #111827;
  margin: 0 0 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'euclid_semi_bold', sans-serif;
}

.edit-button {
  background: none;
  border: none;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  font-family: 'euclid_regular', sans-serif;
}

.edit-button:hover {
  text-decoration: underline;
}

.billing-details {
  margin-bottom: 32px;
}

.billing-details span {
  font-size: 12px;
  font-family: 'Euclid Circular A', sans-serif;
  color: #98a2b2;
}

.billing-details p{
  font-size: 12px;
  font-family: 'Euclid Circular A', sans-serif;
}

.address, .phone {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}

.payment-header {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-bottom: 32px;
}

.card-select-wrapper {
  flex: 1;
  min-width: 0;
  position: relative;
}

.card-select-trigger {
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  background: #F5F5F5;
  padding: 10px 0 10px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
}

.card-select-display {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding-right: 10px;
}

.card-select-icon {
  width: 35px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
}

.card-select-text {
  font-size: 14px;
  font-family: 'euclid_medium', sans-serif;
  color: #434343;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-select-expiry {
  color: #717171;
  font-size: 12px;
  margin-left: 8px;
}

.card-select-placeholder {
  font-size: 14px;
  font-family: 'euclid_regular', sans-serif;
  color: #717171;
  white-space: nowrap;
}

.card-select-arrow {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  flex-shrink: 0;
  transition: transform 0.2s;
}

.card-select-arrow.rotated {
  transform: rotate(180deg);
}

.card-select-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #EAECF0;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 99999;
  max-height: 200px;
  overflow-y: auto;
}

.card-select-dropdown::-webkit-scrollbar {
  width: 15px;
}

.card-select-dropdown::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #fff;
}

.card-select-dropdown::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.card-select-dropdown::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.card-select-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'euclid_regular', sans-serif;
  font-size: 12px;
}

.card-select-option:hover {
  background-color: #F5F7FA;
}

.card-select-option.selected {
  background-color: #F5F7FA;
}

.card-option-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.card-option-brand {
  font-size: 13px;
  font-family: 'euclid_medium', sans-serif;
  color: #434343;
}

.card-option-number {
  font-size: 11px;
  font-family: 'euclid_regular', sans-serif;
  color: #717171;
}

.card-option-expiry {
  font-size: 11px;
  font-family: 'euclid_regular', sans-serif;
  color: #717171;
  flex-shrink: 0;
}

.no-card-info {
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  background: #F5F5F5;
  padding: 10px 15px;
  display: flex;
  align-items: center;
}

.no-card-info span {
  color: #717171;
  font-size: 14px;
  font-family: 'euclid_regular', sans-serif;
}

.new-card-button {
  background: none;
  border: none;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  font-family: 'euclid_regular', sans-serif;
}

.new-card-button:hover {
  text-decoration: underline;
}

.complete-payment-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #111827;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 16px;
  font-size: 16px;
  font-family: 'euclid_medium', sans-serif;
  cursor: pointer;
  margin-bottom: 16px;
}

.complete-payment-btn:hover {
  background: #1f2937;
  transform: translateY(-1px);
}

.complete-payment-btn:disabled {
  background: #d1d5db;
  color: #6b7280;
  cursor: not-allowed;
  transform: none;
}
.complete-payment-btn:disabled:hover {
  background: #d1d5db;
  transform: none;
}

.payment-disabled-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #b91c1c;
  text-align: center;
  line-height: 1.4;
}

.payment-notice {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 12px;
}

.payment-notice p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}

.payment-notice svg {
  display: flex;
  height: 20px;
  width: 20px;
}

.right-section {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 12px;
  align-self: start;
}

.plan-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}

.plan-info h3 {
  font-size: 20px;
  color: #111827;
  margin: 0 0 4px 0;
  font-family: 'euclid_semi_bold', sans-serif;
}

.plan-info p {
  color: #6b7280;
  margin: 0;
  font-size: 12px;
  font-family: 'euclid_regular', sans-serif;
}

.features-title {
  display: flex;
  font-size: 16px;
  color: #111827;
  margin: 0 0 16px 0;
  font-family: 'euclid_medium', sans-serif;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;
}

.features-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #374151;
  line-height: 1.5;
}

.summary-title {
  font-size: 16px;
  color: #111827;
  margin: 0 0 16px 0;
  font-family: 'euclid_semi_bold', sans-serif;
}

.pricing-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.pricing-label {
  color: #6b7280;
  font-size: 14px;
}

.pricing-value {
  color: #111827;
  font-size: 14px;
}

.discount-value {
  color: #2563eb;
}

.pricing-summary {
  margin-bottom: 22px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.schedule-left, .schedule-right {
  display: flex;
  flex-direction: column;
}

.monthly-amount, .payment-date {
  font-size: 16px;
  color: #101927;
  margin-bottom: 4px;
  font-family: 'euclid_regular';
}

.monthly-price, .next-payment {
  font-size: 24px;
  color: #111827;
}

.schedule-discount {
  display: block;
  font-size: 12px;
  color: #16a34a;
  margin-top: 2px;
  font-family: 'euclid_regular';
}

.billing-notice {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 16px;
}

.billing-notice p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}

.billing-notice svg {
  display: flex;
  height: 18px;
  width: 18px;
}

@media (max-width: 768px) {
  .modal-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .left-section {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    padding-right: 0;
    padding-bottom: 24px;
  }

  .right-section {
    padding-left: 0;
  }

  .schedule-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}

.dot{
  display: flex;
  width: 100%;
  border: 0.5px solid #e5e7eb;
  margin-bottom: 24px;
}

.schedule-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 20px;
}

.date-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.date-label {
  font-size: 12px;
  color: #6b7380;
  font-family: 'euclid_regular', sans-serif;
  white-space: nowrap;
}

.date-value {
  font-size: 16px;
  color: #111827;
  font-weight: 600;
  font-family: 'euclid_semi_bold', sans-serif;
  white-space: nowrap;
}
</style>
